module.exports = __webpack_public_path__ + "55d6f80e4532d30b64894e6caa71b0e2.pdf";